// Store action dispatch with getter check to see if already loaded.
export function fakeIt(data){
    return asPromise({data,delay:250});
}

export function asPromise({data,delay=0}) {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(JSON.parse(JSON.stringify(data))), delay);
    });
}